import { render, staticRenderFns } from "./empty_default.vue?vue&type=template&id=fb8c7606&lang=pug&"
import script from "./empty_default.vue?vue&type=script&lang=js&"
export * from "./empty_default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports